import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import FilterModal from "./FilterModal";
import { ReactComponent as Empty } from "assets/icons/empty-table.svg";
import useTableFilter from "hooks/tableFilter";

import TableManipulation from "components/General/Table/TableManipulation";
import Table from "components/General/Table";
import { ReactComponent as SearchIcon } from "assets/icons/SearchIcon/searchIcon.svg";
import { pageCount } from "utils/appConstant";

import { hasValue } from "utils/validations";
import { numberWithCommas, capitalizeString } from "utils/formatter";
import { transactionAmountValue } from "utils/transactions";
import useWindowDimensions from "hooks/useWindowDimensions";
import transactionsSlice from "pages/Dashboard/Transactions/slice";
import CircleLoader from "components/General/CircleLoader/CircleLoader";
import { TRANSACTION_MODAL_SCREENS } from "utils/modalScreens";
import { TransactionDetailsModal } from "./ModalScreens";
import { getCellContent } from "utils/functions";
import apis from "services/merchant";

const { TRANSACTION_DETAILS } = TRANSACTION_MODAL_SCREENS;

export const requiredFilters = {
  start_date: "2020-01-01",
  end_date: moment().format("YYYY-MM-DD"),
  tribe_account_id: "fiat",
};
export default function TransactionsList({
  setCurrentWalletModal,
  tribe_account_id,
}) {
  const { merchantDetails } = useSelector((state) => state.marchants);

  const requiredFilters = {
    start_date: "2022-01-01",
    end_date: moment().format("YYYY-MM-DD"),
    tribe_account_id: "",
  };

  const defaultFilters = {
    start_date: "",
    end_date: "",
  };

  const { isMobile } = useWindowDimensions();

  const [currentPage, setCurrentPage] = useState(1);
  const [currentModal, setCurrentModal] = useState("");

  const [modalVisible, setModalVisible] = useState(false);

  const { actions } = transactionsSlice;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Parse the query string
  // const searchParams = new URLSearchParams(location.search);
  // const transaction_reference = searchParams.get("transaction_reference");

  const { cryptoLoading, cryptoTransactions } = useSelector(
    (state) => state.transactions
  );

  const {
    filterInput,
    setFilterInput,
    filterData,
    handleFilter,
    clearFilters,
  } = useTableFilter({
    defaultFilters,
    setFilterModal: setModalVisible,
    currentPage,
    setCurrentPage,
  });

  const currentParams = new URLSearchParams(window.location.search);
  const viewTransactionDetails = (txn) => {
    console.log(txn);
    const transaction_reference =
      txn?.payment_ref || txn?.transaction?.payment_ref;
    setCurrentModal(TRANSACTION_DETAILS);
    console.log(transaction_reference);
    currentParams.set("transaction_reference", transaction_reference);
    navigate(`${window.location.pathname}?${currentParams.toString()}`);
  };

  const closeTransactionDetails = () => {
    // Remove the 'transaction_reference' parameter
    setCurrentModal("");
    currentParams.delete("transaction_reference");
    // Update the URL without reloading the page
    navigate(`${location.pathname}?${currentParams.toString()}`);
  };

  // useEffect(() => {
  //   if (transaction_reference) {
  //     viewTransactionDetails({ transaction_reference });
  //   }
  // }, [transaction_reference]);

  const fetchTransactions = () => {
    let filters = {};
    Object.keys(filterData).forEach((item) => {
      filters = {
        start_date: hasValue(filterData.start_date)
          ? filterData.start_date
          : requiredFilters.start_date,
        end_date: hasValue(filterData.end_date)
          ? filterData.end_date
          : requiredFilters.end_date,
        tribe_account_id: filterData.tribe_account_id?.value,
      };
    });

    dispatch(
      actions.getCryptoTransactionsList({
        payload: filters,
        tribeRef: merchantDetails.account_tribe_ref,
        page: currentPage,
      })
    );
  };

  useEffect(() => {
    if (filterData.tribe_account_id?.value) {
      let timeoutId;

      const delayedFetch = () => {
        timeoutId = setTimeout(() => {
          fetchTransactions();
        }, 50); // Adjust the delay time as needed
      };

      // Clear the previous timeout every time dependencies change
      clearTimeout(timeoutId);

      // if (merchantDetails?.account_tribe_ref) {
      delayedFetch();
      // }

      // Cleanup function to clear timeout if component unmounts or dependencies change
      return () => clearTimeout(timeoutId);
    }
  }, [filterData, currentPage]);

  const columns = [
    ...(isMobile
      ? [
          {
            name: "Coin Type",
            minWidth: "35%",
            maxWidth: isMobile ? "45%" : "",
            selector: (row) => (
              <div onClick={() => viewTransactionDetails(row)}>
                {getCellContent(row.coin_type?.toUpperCase())}
              </div>
            ),
          },
          {
            name: "Coin Amount",
            minWidth: "20%",
            maxWidth: isMobile ? "40%" : "",
            selector: (row) => transactionAmountValue(row),
            cell: (row) => (
              <div onClick={() => viewTransactionDetails(row)}>
                {getCellContent(numberWithCommas(row.coin_amount))}
              </div>
            ),
            sortable: true,
          },
        ]
      : [
          {
            name: "Coin Type",
            minWidth: "10%",
            maxWidth: isMobile ? "40%" : "15%",
            selector: (row) => transactionAmountValue(row),
            cell: (row) => (
              <div onClick={() => viewTransactionDetails(row)}>
                {getCellContent(row.coin_type?.toUpperCase())}
              </div>
            ),
            sortable: true,
          },
          {
            name: "Coin Amount",
            minWidth: "20%",
            maxWidth: isMobile ? "40%" : "20%",
            selector: (row) => transactionAmountValue(row),
            cell: (row) => (
              <div onClick={() => viewTransactionDetails(row)}>
                {getCellContent(numberWithCommas(row.coin_amount))}
              </div>
            ),
            sortable: true,
          },
          {
            name: "Fiat Amount",
            minWidth: "15%",
            maxWidth: isMobile ? "40%" : "15%",
            selector: (row) => transactionAmountValue(row),
            cell: (row) => (
              <div onClick={() => viewTransactionDetails(row)}>
                {row?.merch_currency}{" "}
                {getCellContent(numberWithCommas(row.merch_amount))}
              </div>
            ),
            sortable: true,
          },
          {
            name: "Status",
            minWidth: "10",
            // maxWidth: isMobile ? "40%" : "",
            selector: (row) => (
              <div onClick={() => viewTransactionDetails(row)}>
                {getCellContent(capitalizeString(row.transaction_status))}
              </div>
            ),
          },
        ]),
    {
      name: "Payment Ref",
      minWidth: "30%",
      maxWidth: isMobile ? "40%" : "20%",
      selector: (row) => transactionAmountValue(row),
      cell: (row) => (
        <div onClick={() => viewTransactionDetails(row)}>
          {getCellContent(row.payment_ref)}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Date",
      minWidth: "23%",
      selector: (row) => new Date(row.pub_date),
      cell: (row) => (
        <div onClick={() => viewTransactionDetails(row)}>
          {getCellContent(moment(row.pub_date).format("DD MMM h:mmA"))}
        </div>
      ),
      sortable: true,
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => scrollToTop(), []);

  const fetchAccounts = (inputValue) => {
    return apis
      .searchMerchants({
        data: {
          account_trade_name: inputValue,
          account_type: "merchant",
          start_date: "2020-01-01",
          end_date: moment().format("YYYY-MM-DD"),
        },
        page: 1,
      })

      .then((res) => {
        return res?.data?.map((item) => ({
          name: item?.tribe_account_id,
          label: item?.account_legal_name,
          value: item?.tribe_account_id,
        }));
      });
  };

  return (
    <>
      <div className="h-full md:pr-4">
        <div className="flex flex-col justify-start items-center h-full w-full space-y-7">
          <div className="flex justify-between items-center w-full">
            <h3 className="text-xl whitespace-nowrap">Crypto Transactions</h3>
          </div>
          <div className="flex flex-col justify-start items-center w-full space-y-3 md:hidden">
            <TableManipulation
              onFilter={() => setModalVisible(true)}
              searchLoading={cryptoLoading}
              className="md:hidden h-fit w-full"
              filtersClassName="flex flex-col h-fit w-full gap-3"
              filterButtonProps={{ fullWidth: true }}
              exportButtonProps={{ fullWidth: true }}
            />
          </div>

          <TableManipulation
            onFilter={() => setModalVisible(true)}
            className="hidden md:flex"
            searchClass=""
            searchLoading={cryptoLoading}
          />
          {cryptoLoading ? (
            <CircleLoader blue />
          ) : (
            <>
              <div className="flex flex-col flex-grow justify-start items-center w-full h-full rounded-lg">
                {cryptoTransactions?.data?.length > 0 ? (
                  <Table
                    data={cryptoTransactions?.data}
                    columns={isMobile ? columns.slice(0, 2) : columns}
                    // onRowClicked={viewTransactionDetails}
                    pointerOnHover
                    isLoading={cryptoLoading}
                    pageCount={cryptoTransactions?.count / pageCount}
                    onPageChange={(page) => setCurrentPage(page)}
                    currentPage={currentPage}
                    noDataComponent={
                      <div className="text-grey-text flex flex-col justify-center items-center h-full mt-10 mb-16">
                        <Empty />
                      </div>
                    }
                    noPadding
                  />
                ) : (
                  <>
                    <div className="text-grey-text flex flex-col justify-center items-center space-y-3 h-full">
                      <SearchIcon className="stroke-current" />
                      <span>Filter and search Account Crypto transactions</span>
                    </div>
                    <div className="text-grey-text flex flex-col justify-center items-center h-full">
                      <Empty />
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        {currentModal === TRANSACTION_DETAILS ? (
          <TransactionDetailsModal
            active={currentModal === TRANSACTION_DETAILS}
            toggler={closeTransactionDetails}
            details={{
              modalType: TRANSACTION_DETAILS,
              clearFilters: () => {
                clearFilters();
              },
              getTransaction: () => {
                fetchTransactions();
              },
            }}
          />
        ) : null}

        {modalVisible && (
          <FilterModal
            active={modalVisible}
            onClose={() => setModalVisible(false)}
            setFilterData={setFilterInput}
            filterData={filterInput}
            fetchAccounts={fetchAccounts}
            handleFilter={handleFilter}
            clearFilters={clearFilters}
            modalType={"SEARCH_FILTER"}
          />
        )}
      </div>
    </>
  );
}
TransactionsList.propTypes = {
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  currentWalletModal: PropTypes.string,
  tribe_account_id: PropTypes.string,
  setCurrentWalletModal: PropTypes.func,
};
